import { EButtonLinkType } from '@common/enums';

export const LINK_TYPE_NAME: Readonly<Record<EButtonLinkType, string>> = {
    [EButtonLinkType.link]: 'control_link',
    [EButtonLinkType.email]: 'control_email',
    [EButtonLinkType.phone]: 'control_phone',
    [EButtonLinkType.anchor]: 'control_anchor',
};

export const LINK_TYPES = [
    { name: LINK_TYPE_NAME[EButtonLinkType.link], type: EButtonLinkType.link },
    { name: LINK_TYPE_NAME[EButtonLinkType.email], type: EButtonLinkType.email },
    { name: LINK_TYPE_NAME[EButtonLinkType.phone], type: EButtonLinkType.phone },
    { name: LINK_TYPE_NAME[EButtonLinkType.anchor], type: EButtonLinkType.anchor },
];

export const BUTTON_LINK_TYPE_PLACEHOLDER: Record<EButtonLinkType, string> = {
    [EButtonLinkType.email]: 'ask@mail.com',
    [EButtonLinkType.phone]: '+12223334455',
    [EButtonLinkType.link]: 'https://site.com',
    [EButtonLinkType.anchor]: '',
};
